import apiClient from "../helpers/apiClient";

export const getSections = async () => {
    try {
        const response = await apiClient.get(`auth/section/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching classifiers:', error);
        throw error;
    }
}


export const createSection = async (section: 'CLAIM' | 'ASSETS', is_default: boolean) => {
    try {
        const response = await apiClient.post(`auth/section/`, { section, is_default });
        return response.data;
    } catch (error) {
        console.error('Error fetching classifiers:', error);
        throw error;
    }
}

export const setAsDefaultSection = async (id: number, is_default: boolean) => {
    try {
        const response = await apiClient.patch(`auth/section/${id}/`, { is_default });
        return response.data;
    } catch (error) {
        console.error('Error fetching classifiers:', error);
        throw error;
    }
}